import MaterialTable, { MTableCell } from '@material-table/core';
import merge from 'lodash.merge';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useLocalization } from '../../contexts/localizationContext';
import { getLocalization } from './tableLocalization';

const dateTypes = ['date', 'datetime'];

export default function Table({ title = '', localization, options, ...otherProps  }) {
  const appLocalization = useLocalization();
  const intl = useIntl();

  const mergedLocalization = useMemo(() => getLocalization(localization, appLocalization.locale, intl.formatMessage), [localization, appLocalization.locale]);
  const mergedOptions = useMemo(() => getOptions(options), [options]);

  return <MaterialTable
    key={appLocalization.locale}
    title={title}
    localization={mergedLocalization}
    options={mergedOptions}
    components={{
      // eslint-disable-next-line react/prop-types
      Cell: ({ value, columnDef, ...otherProps }) => {
        let newValue = value;
        let newColumnDef = columnDef;
        if (value && newColumnDef.type && dateTypes.includes(newColumnDef.type)) {
          newValue = intl.formatDate(newValue, { dateStyle: 'short', timeStyle: 'short' });
          newColumnDef = merge({}, newColumnDef, { type: 'string' });
        }
        return (
          <MTableCell value={newValue} columnDef={newColumnDef} {...otherProps} />
        );
      }
    }}
    {...otherProps}
  />;
}

Table.propTypes = {
  title: PropTypes.string,
  localization: PropTypes.any,
  options: PropTypes.any
};


function getOptions(options) {
  return merge({}, {
    emptyRowsWhenPaging: false,
    actionsColumnIndex: -1
  }, options);
}